import { render } from "./EmergencyBanner.vue?vue&type=template&id=4cf2cd66"
import script from "./EmergencyBanner.vue?vue&type=script&lang=js"
export * from "./EmergencyBanner.vue?vue&type=script&lang=js"

import "./EmergencyBanner.vue?vue&type=style&index=0&id=4cf2cd66&lang=scss"

import exportComponent from "/codebuild/output/src187469640/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__